<div style="background-color: #161A29">
  @if (!this.data.isExpert) {
    <div id="floatButtons" class="float-buttons">
      <div class="round-button close-button float-button">
        <img src="/assets/images/buttons/close.svg" alt="Icono" (click)="close()">
      </div>
      @if (this.data.isLiveMode) {
        <div class="round-button capture-tool-button float-button">
          <img src="/assets/images/buttons/capture/eraser.svg" alt="eraser" title="eraser" (click)="eraseAll()">
        </div>
      }
    </div>
  }

  <div id="imageContainer" class="divContainer">
    <canvas id="canvasSurface" class="divContainer" #canvasRec></canvas>
  </div>
</div>
